<img src="./assets/media/svg/icons/General/Edit-3.svg" title="Edit" (click)="invokeParentMethod()">

&nbsp;

<a href="javascript:;"
   routerLink="/activity-list/1"> 
    <img src="./assets/media/svg/icons/General/dashboard.svg" ngbTooltip="Dashboard">
</a>